// The device's IANA timezone — exact and free (Doc 04 §6). Used for the calendar-rough
// home grouping and the trip countdown; the timezone-precise logic lives at the
// reminder/email boundary (Doc 09).
export const deviceTimezone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;
